export default {
      id: "icon-facebook-usage",
      viewBox: "0 0 10.835 21.667",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }